import { updateEvent } from '@wix/ambassador-events-v3-event/http';
import { chunk as getChunks } from 'lodash';
import { fetchEvents } from '../new-infra-fetchers/fetch-events';
import { buildEventsBulkUpdatePayload } from './build-payloads/bulk-update-events-alt-text-payload-builder';
const BULK_LIMIT = 100;
export const updateEventsImageAlt = async (httpClient, errorHandler, t, altTextData) => {
  const {
    withErrorHandler,
    getResolvedError
  } = errorHandler;
  const entityIdsList = altTextData.map(item => item.entityId).filter(entityId => entityId !== undefined);
  try {
    const events = await fetchEvents(httpClient, errorHandler, t, entityIdsList);
    const eventsMap = new Map(events.map(event => [event.id, event]));
    const allFailedElements = [];
    const chunks = getChunks(altTextData, BULK_LIMIT);
    const results = [];
    for (const chunk of chunks) {
      const payload = buildEventsBulkUpdatePayload(chunk, eventsMap);
      if (payload.length === 0) {
        results.push({
          success: false
        });
        allFailedElements.push(...chunk);
        continue;
      }
      const chunkPromises = payload.map(async event => {
        const {
          data: {
            event: updatedEvent
          }
        } = await withErrorHandler(async () => httpClient.request(updateEvent(event)), {
          errorCodesMap: {
            applicationError: {
              INVALID_EVENT_STATUS_TRANSITION: false,
              INVALID_SLUG_FORMAT: false,
              SLUG_ALREADY_IN_USE: false
            }
          }
        });
        return {
          success: !!updatedEvent
        };
      });
      const chunkResults = await Promise.all(chunkPromises);
      const success = chunkResults.every(result => result.success);
      if (!success) {
        const failedIndexes = (chunkResults ?? []).map((_item, index) => index).filter(index => index !== undefined);
        const failedElementsChunk = chunk.filter((_, index) => failedIndexes.includes(index));
        allFailedElements.push(...failedElementsChunk);
      }
      results.push({
        success
      });
    }
    const overallSuccess = results.every(result => result.success);
    return {
      failedElements: allFailedElements,
      success: overallSuccess
    };
  } catch (error) {
    return {
      errorMessage: getResolvedError(error).message,
      failedElements: altTextData,
      success: false
    };
  }
};
//# sourceMappingURL=update-events-alt-text.js.map